// extracted by mini-css-extract-plugin
export var button = "GoToTop-module--button--73c7f";